document.addEventListener( 'DOMContentLoaded', function () {

  /*
  ======================================================
  1. MERGE SECOND-ROW COLUMNS INTO FIRST ROW
  ======================================================
  */

  const menus = document.querySelectorAll( '.mega-sub-menu' );

  menus.forEach( menu => {
    const rows = menu.querySelectorAll( ':scope > li.mega-menu-row' );

    if ( rows.length < 2 ) return;

    const firstRow = rows[0].querySelector( ':scope > ul.mega-sub-menu' );
    const secondRow = rows[1].querySelector( ':scope > ul.mega-sub-menu' );

    if ( !firstRow || !secondRow ) return;

    const secondRowColumns = secondRow.querySelectorAll( ':scope > li.mega-menu-column' );
    secondRowColumns.forEach( col => firstRow.appendChild( col ) );

    if ( secondRow.querySelectorAll( ':scope > li' ).length === 0 ) {
      rows[1].remove();
    }
  } );


  /*
  ======================================================
  2. WRAP FULL COLUMN IN ANCHOR (Dynamic URL)
  ======================================================
  */

  // Target the specific widget column (your ID)
  const columnMenu = document.querySelector( '.mega-menu-column:has(.widget_text) > ul.mega-sub-menu' );

  if ( columnMenu ) {

    // Find first internal <a> to extract its href dynamically
    const innerLink = columnMenu.querySelector( 'a' );

    if ( !innerLink ) return; // no link inside → skip

    const linkHref = innerLink.getAttribute( 'href' ) || '#';

    // Create the wrapper anchor
    const wrapper = document.createElement( 'a' );
    wrapper.href = linkHref;
    wrapper.className = 'mega-column-wrapper-link';

    // Move all children into this wrapper anchor
    while ( columnMenu.firstChild ) {
      wrapper.appendChild( columnMenu.firstChild );
    }

    columnMenu.appendChild( wrapper );
  }

} );
